

import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from './MenuListComponent.module.css';
import { menuMenuActions } from "../../../store/slices/menu-slices";
import MenuPacksSingleComponent from "../MenuPacksSingleComponent/MenuPacksSingleComponent";
import { useInitCalendarDate } from "../../../helpers";

const MenuListComponent = ({ setIsOpen }) => {
    useInitCalendarDate();

    const dispatch = useDispatch();
    const { menuMenuPacksArray, trigger } = useSelector(store => store.menuMenu);
    const { dataOfDay } = useSelector(store => store.availableDishes);
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;

    useEffect(() => {
        if (dataOfDay) {
            dispatch(menuMenuActions.getAllMenuPacks({ currentData: dataOfDay }));
        }
    }, [trigger, dataOfDay, dispatch]);

    const grouped = useMemo(() => {
        if (!menuMenuPacksArray?.length) return [];

        const map = new Map();

        for (const pack of menuMenuPacksArray) {
            const cat = pack.packCategory;
            const key = cat?.id ?? '__none__';

            if (!map.has(key)) {
                map.set(key, { category: cat ?? null, packs: [] });
            }
            map.get(key).packs.push(pack);
        }

        const groups = Array.from(map.values());

        // sort: named categories first (in order they appear), uncategorized last
        groups.sort((a, b) => {
            if (!a.category && b.category) return 1;
            if (a.category && !b.category) return -1;
            return 0;
        });

        return groups;
    }, [menuMenuPacksArray]);

    return (
        <div className={css.wrap}>
            {grouped.map(({ category, packs }) => (
                <div key={category?.id ?? '__none__'} className={css.categoryGroup}>
                    <div className={css.categoryHeader}>
                        {category?.icon && (
                            <img
                                src={category.icon}
                                alt=""
                                className={css.categoryIcon}
                            />
                        )}
                        <span className={css.categoryName}>
                            {category
                                ? (category.name[currentLanguage] || category.name['en'])
                                : 'Uncategorized'}
                        </span>
                        <span className={css.categoryCount}>{packs.length}</span>
                        <div className={css.categoryDivider} />
                    </div>

                    {packs.map(obj => (
                        <MenuPacksSingleComponent
                            key={obj.id}
                            pack={obj}
                            setIsOpen={setIsOpen}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default React.memo(MenuListComponent);
